import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getStepFieldSettings } from '../../../utils/step-field';
import { getStepValidator } from './get-step-validator';
export function useFormFieldsData(_ref) {
  var _ref$steps = _ref.steps,
    steps = _ref$steps === void 0 ? [] : _ref$steps;
  var _steps$reduce = steps.reduce(function (acc, step) {
      var fieldSettings = getStepFieldSettings(step);
      if (fieldSettings && fieldSettings.name) {
        var name = fieldSettings.name,
          value = fieldSettings.value;
        acc.fieldsMap[name] = _objectSpread(_objectSpread({}, fieldSettings), {}, {
          quizStepType: step.type
        });
        if (step.type === 'checkbox-group') {
          acc.initialValues[name] = [];
        } else if (step.type === 'rating') {
          acc.initialValues[name] = {
            rating: value || ''
          };
        } else {
          acc.initialValues[name] = value || '';
        }
        acc.fieldsValidators[name] = getStepValidator(step);
      }
      return acc;
    }, {
      initialValues: {},
      fieldsValidators: {},
      fieldsMap: {}
    }),
    fieldsValidators = _steps$reduce.fieldsValidators,
    fieldsMap = _steps$reduce.fieldsMap,
    initialValues = _steps$reduce.initialValues;
  return {
    fieldsValidators: fieldsValidators,
    fieldsMap: fieldsMap,
    initialValues: initialValues
  };
}